import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import styled from 'styled-components'
import {Box} from 'rebass';
import Messages from "../Chat/Messages";
import InputToolbar from '../Chat/InputToolbar'

import IosArrowBack from "react-ionicons/lib/IosArrowBack";

import { 
    Header,
    Right,
    Left,
	LeftText,
	WithIconBox,
	InputWrapper
} from './Styles';

const MessageContainer = styled(Box)`
    height: 400px;
    // overflow-y: scroll;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #ffffff;
    background-color: #ffffff;
`

class ChatMessageList extends Component {
	constructor(props) {
		super(props);
		this.id = this.props.chatId;
		this.state = {
			width: 0,
			height: 0,
			loading: false,
			members: [],
			messages: [],
			memberIds: [],
			message: '',
			chat: {creator_uid: 1, accepted: {status: 3, updated_at: Date.now() / 1000}, messages: [], members: []}
		};
	}

	componentDidMount() {
		this.listener = this.props.firebase.chat(this.id).onSnapshot(snapshot => {
			const result = {id: snapshot.id, ...snapshot.data()};
			this.updateAsRead(result);
			this.fetchUserDetails(result);

			// this.setState({chat: result})
		})
	}

	fetchUserDetails = async (item) => {
		const {profile, history} = this.props; 
		let ids = [];
		let members = [];
		if(item.members) {
			if (item.members.includes(item.creator_uid)) {
				ids = item.members
			} else {
				ids = [item.creator_uid, ...item.members]

			}
			if(!ids.includes(profile.id)){
				history.push('/app/chat')
			}

			if(item.creator_uid.length !== 4 && item.is_group && item.creator_uid !== profile.id && !item.accepted.members.includes(profile.id)){
				//console.log(!item.accepted.members.includes(profile.id))
				item.messages = []
			}

			let count = 1;
			let idMap = {};
			for (let i in ids) {
				if (ids[i] === profile.id) {
					idMap[ids[i]] = {id: 0, senderName: 'You'}
				} else {
					idMap[ids[i]] = {id: count, senderName: ''};
					count++;
				}
			}
			try {
				for (let i in ids) {
					if (ids[i] !== profile.id) {
						if (ids[i].length === 7) {
							//let data = {id: ids[i], ...studentMap[ids[i]]};
							let student = await this.props.firebase.student(ids[i]).get();
							let data = {id: student.id, ...student.data()}
							members.push(data);
							idMap[data.id].senderName = data.first_name
							idMap[data.id].profileImage = data.profile_pic
						} else {
							//let data = {id: ids[i], ...facultyMap[ids[i]]};
							let faculty = await this.props.firebase.faculty(ids[i]).get();
							let data = {id: faculty.id, ...faculty.data()}
							members.push(data);
							idMap[data.id].senderName = data.first_name
							idMap[data.id].profileImage = data.profile_pic
						}
					}
				}
				let messages = [];
				for (let x = 0; x < item.messages.length; x++) {
					let user = idMap[item.messages[x].uid];
					// let member = members.filter(user => user.id === item.messsages[x].uid)
					if (user) {
						let message = item.messages[x]
						messages.push({
							id: user.id,
							message: item.messages[x].message,
							senderName: user.senderName,
							postTime: item.messages[x].created_at,
							profile_pic: user.profileImage,
							has_attachment: message.has_attachment === true,
							attachment: message.attachment,
							type: message.attachment_type,
							file_name: message.file_name
						})

					}
				}
				item.members = members;
				this.setState({chat: item, messages: messages, members, idMap: idMap, memberIds: ids})

			} catch (error) {
				//console.log(error)
			}
		}
	};

	updateAsRead = async (item) => {
		const {profile} = this.props;
		let messages = item.messages;
		let updated = false;
		for (let i in messages) {
			if (!messages[i].seen.includes(profile.id)) {
				messages[i].seen.push(profile.id);
				updated = true;
			}
		}

		try {
			if(updated) {
				let chatRef = this.props.firebase.chats().doc(item.id);
				chatRef.update({messages: messages})
			}
		} catch (error) {
			//console.log(error)
		}
	};

	componentWillUnmount() {
		this.listener()
	}

	
	onBackClick = (e) => {
		e.stopPropagation();
		this.props.back();
	}

	render() {

		const {profile, isFaculty, isMinimized} = this.props;
		const {chat, members, messages} = this.state;

		const nameList = chat.members.filter(member => member.id !== profile.id).map((member, i) => i > 0 ? (member.first_name + ' ' + member.last_name) : (member.first_name + ' ' + member.last_name));
		let chatTitle = 'Chat'
		if(chat.is_group){
			if(chat.name !== ''){
				chatTitle = chat.name
			} else {
				chatTitle = `Group Chat (${chat.members.length })`
			}
		}else if(nameList.length > 0){
			chatTitle = nameList.join(', ');

		}
		if (chat.name && chat.name !== '') {
			chatTitle = chat.name + ` (${chat.members.length})`
		}
		if (chatTitle.length > 15) {
			chatTitle = chatTitle.slice(0, 13) + '...'
		}


		return (
			<>
				 <Header onClick={this.props.toggleBox}>
					<Left
						p={3}
						width={3/4}
					>
						<WithIconBox onClick={(e) => this.onBackClick(e)}>
							<IosArrowBack fontSize={'30px'} color={'white'} />
							<LeftText>
								{chatTitle}
							</LeftText>
						</WithIconBox>
					</Left>
					<Right
						p={3}
						width={1/4}
					>
					</Right>
                </Header>
				{
					!isMinimized && 
					<MessageContainer>
						<Messages messages={messages} height={'348px'} profile={profile} chat={chat}/>
						<InputWrapper>
							<InputToolbar
								selected={chat}
								profile={profile}
								isFaculty={isFaculty}
								members={members}
								isPopup
							/>
						</InputWrapper>
					</MessageContainer>
				}
				
			</>
			
		);
	}
}


export default withRouter(ChatMessageList)
